import React from "react";
import NewAuth from "./NewAuth";

export default function Login(props) {
  return <NewAuth isSignup={false} {...props} />;
}
